import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { API_BASE } from '../config/api';

const SKIP = /^\/(login|auth|sso|set-password|reset-password|forgot-password)/;

export const trackActivity = (token, path, lesson) => {
  if (!token || !path || SKIP.test(path)) return;
  axios.post(`${API_BASE}/api/activity/track`, { path, lesson: lesson || null }, { headers: { Authorization: `Bearer ${token}` } }).catch(() => {});
};

// Records every page a signed-in user opens for their audit log.
export default function ActivityTracker() {
  const { token } = useAuth();
  const { pathname } = useLocation();
  const last = useRef('');
  useEffect(() => {
    const key = `${token ? 'y' : 'n'}|${pathname.replace(/\/ai-learn$/, '/learn')}`;
    if (!token || last.current === key) return;
    last.current = key;
    trackActivity(token, pathname);
  }, [token, pathname]);
  return null;
}
